exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1.margin-top{margin-top:14rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/stylus-loader!./components/App/index.styl
// module id = 461
// module chunks = 0